import { gql } from "@apollo/client";
import { Job as job } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_JOB_REQUEST = props => gql`
  query FetchJob($id: Int!) {
    job(id: $id) {
      ${job(props)}
    }
  }
`;

const FETCH_JOB_REQUESTS_V2 = props => gql`
  query FetchJobsV2($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      count
      edges {
        ${job(props)}
      }
      sqlQuery
    }
  }
`;

const JOB_LIST_FIELDS = `
  count
  edges {
    id
    date
    description
    dueDate
    duetime
    jobStatus {
      description
    }
    jobType {
      description
    }
    pickupGroup {
      name
    }
  }
`;

const FETCH_JOBS_LIST = gql`
  query FetchJobsV2($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      ${JOB_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_JOBS_SEARCH_RESULTS = gql`
  query FetchJobsSearchResults($input: AdvJobFilterInput!) {
    jobsV2(input: $input) {
      ${JOB_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

export {
  FETCH_JOB_REQUEST,
  FETCH_JOB_REQUESTS_V2,
  FETCH_JOBS_LIST,
  FETCH_JOBS_SEARCH_RESULTS,
};
